import styled from 'styled-components';
import { Link } from 'gatsby';

import * as text from '@/components/general/TextStyles';

export const NavBar = styled.ul<{ $hideOnLg?: boolean }>`
  ${text.FS14}
  display: flex;
  width: 100%;
  align-items: center;
  position: absolute;
  column-gap: 6.5px;
  top: 30px;
  color: ${(props) => props.theme.colors.grayText};

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: ${(props) => props.$hideOnLg && 'none'};
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  display: flex;
  align-items: center;
`;

export const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  transition: ${(props) => props.theme.transition.primary};

  &:hover {
    color: ${(props) => props.theme.colors.black};
  }
`;

export const NavText = styled.span`
  cursor: pointer;
  transition: ${(props) => props.theme.transition.primary};
  &:hover {
    color: ${(props) => props.theme.colors.black};
  }
`;

export const NavArrow = styled.img`
  margin: 0 0 0 6.5px;
`;
